import * as React from 'react';
import { cn } from '@relay-towing/tokens';
import {
  sidebarFooterRecipe,
  sidebarFrameRecipe,
  sidebarPagesRecipe,
  sidebarToolbarRecipe,
} from '../recipes/nav.recipe';
import { BrandMark } from './BrandMark';

export interface SidebarFrameProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Along the top: the history arrows, and the collapse toggle at the right. */
  toolbar?: React.ReactNode;
  /** The pages: the rows of NavItems. */
  children?: React.ReactNode;
  /** Pinned to the bottom: the company and the person. */
  footer?: React.ReactNode;
}

/**
 * The dashboard's sidebar, as its Figma draws it (17:2777): the toolbar, the
 * Relay wordmark, the pages under it, and the foot. The app fills the slots
 * and decides what each holds; this decides where they go.
 *
 *   <SidebarFrame
 *     toolbar={<><HistoryArrows /><CollapseToggle /></>}
 *     footer={<><SidebarCompanySelectorView … /><SidebarUserProfileView … /></>}
 *   >
 *     {links.map((link) => <NavItem … />)}
 *   </SidebarFrame>
 */
export const SidebarFrame = React.forwardRef<HTMLDivElement, SidebarFrameProps>(
  function SidebarFrame(
    { toolbar, footer, children, className, ...props },
    ref
  ) {
    return (
      <div ref={ref} className={cn(sidebarFrameRecipe(), className)} {...props}>
        <div className={sidebarPagesRecipe()}>
          <div className={sidebarToolbarRecipe()}>{toolbar}</div>
          {/* Left, under the arrows: the column stretches its children, and
              a stretched image centres its art. */}
          <BrandMark
            name="relay"
            form="wordmark"
            size="sm"
            alt="Relay"
            className="self-start"
          />
          {children}
        </div>
        {footer ? <div className={sidebarFooterRecipe()}>{footer}</div> : null}
      </div>
    );
  }
);
